"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.watchOnce = void 0;
const watchOnce = (pullPattern, entityId, callback) => {
    const watcher = (before, after) => {
        if (callback(before, after)) {
            window.roamAlphaAPI.data.removePullWatch(pullPattern, entityId, watcher);
        }
    };
    window.roamAlphaAPI.data.addPullWatch(pullPattern, entityId, watcher);
};
exports.watchOnce = watchOnce;
